import PropTypes from 'prop-types';

import { Spinner } from 'react-bootstrap';
import { StyledButton } from './styles';

export default function Button({
  children, type, disabled, onClick, loading,
}) {
  return (
    <StyledButton type={type} disabled={disabled || loading} onClick={onClick}>
      {loading && (<Spinner size="sm" style={{ marginRight: 8 }} />)}
      {children}
    </StyledButton>
  );
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  type: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  loading: PropTypes.bool,
};

Button.defaultProps = {
  type: 'button',
  disabled: false,
  onClick: () => {},
  loading: false,
};
